<ng-container *ngIf="isLoading$ | async; else content"
  ><app-loading-spinner></app-loading-spinner
></ng-container>

<ng-template #content>
  <div class="row justify-content-between">
    <div class="col-lg-6" [formGroup]="form">
      <div class="form-group">
        <label for="websiteName">Website name*</label>
        <input
          formControlName="websiteName"
          type="text"
          class="form-control"
          id="websiteName"
          placeholder="name of the website"
        />
      </div>
      <div class="form-group">
        <label for="accountId">Account ID*</label>
        <input
          formControlName="accountId"
          type="text"
          class="form-control"
          id="accountId"
          placeholder="enter the accountID"
        />
      </div>
      <div class="form-group">
        <label for="sectionId">Section ID*</label>
        <input
          formControlName="sectionId"
          type="text"
          class="form-control"
          id="sectionId"
          placeholder="enter the sectionID"
        />
      </div>
      <div class="form-group">
        <label for="rc4Secret"
          >RC4 secret (autogenerated if left unfilled)</label
        >
        <input
          formControlName="rc4Secret"
          type="text"
          class="form-control"
          id="rc4Secret"
          placeholder="secret key for encrypting emails"
        />
      </div>
      <div class="form-group">
        <label for="fr_client_id">Fresh relevance client ID*</label>
        <input
          formControlName="fr_client_id"
          type="text"
          class="form-control"
          id="fr_client_id"
          placeholder="fresh relevance API client id"
        />
      </div>
      <div class="form-group">
        <label for="fr_token">Fresh relevance secret token*</label>
        <input
          formControlName="fr_token"
          type="text"
          class="form-control"
          id="fr_token"
          placeholder="fresh relevance API secret token"
        />
      </div>
      <div class="form-group">
        <label for="script">Fresh relevance script*</label>
        <textarea
          formControlName="script"
          class="form-control"
          id="script"
          rows="10"
        ></textarea>
      </div>
      <button
        type="button"
        class="btn btn-primary btn-block"
        [disabled]="form.invalid || form.disabled"
        (click)="save()"
      >
        {{ (isUpserting$ | async) ? 'Saving...' : 'Save' }}
      </button>
    </div>
    <div class="col-lg-2" *ngIf="form.value.websiteId">
      <div class="form-group">
        <label for="script"></label>
        <div [style.textAlign]="'right'">
          <button
            type="button"
            class="btn btn-danger btn-block"
            (click)="deleteWebsite()"
            [disabled]="isWebsiteDeleting$ | async"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
